var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.showPill)?_c('b-badge',{staticClass:"pill-button",attrs:{"pill":"","variant":_vm.pillVariant,"href":"#"},on:{"click":_vm.showModal}},[_vm._v(" "+_vm._s(_vm.pillText)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }